// components/WishlistToggle.jsx
// Wishlist state comes from WishlistContext: the server's list, mirrored.
// Guests have none — the toggle asks them to sign in (below).
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { useWishlist } from "../context/WishlistContext";
import { isAuthenticated } from "../utils/auth";
import { showToast } from "../utils/toastManager";

export default function WishlistToggle({ product }) {
  const { addToWishlist, removeFromWishlist, isInWishlist } = useWishlist();
  const productId = product.article_id ?? product.id;
  const inWishlist = isInWishlist(productId);
  const signedIn = isAuthenticated();

  const handleToggle = (e) => {
    e.stopPropagation();

    // Saving is an account feature: the wishlist is the server's, keyed by
    // customer, so a guest has nowhere to put it — ask for the account first
    // instead of pretending it worked. Product opens are gated the same way
    // (see LandingPage).
    if (!signedIn) {
      showToast({
        title: "Sign in to save items",
        message: "Your wishlist follows your account across devices.",
        severity: "info",
      });
      window.dispatchEvent(new CustomEvent("openLoginModal"));
      return;
    }

    if (inWishlist) {
      removeFromWishlist(productId);
    } else {
      addToWishlist({
        id: productId,
        article_id: product.article_id ?? product.id,
        name: product.title || product.enhanced_name || product.name || "Product",
        price: product.price ?? product.price_info?.price ?? 0,
        image: product.image ?? (Array.isArray(product.images) ? product.images[0] : null),
      });
    }
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={`ob-heartbtn ${inWishlist ? "ob-on" : ""}`}
      aria-pressed={signedIn ? inWishlist : undefined}
      aria-label={
        !signedIn
          ? "Sign in to save to your wishlist"
          : inWishlist
          ? "Remove from wishlist"
          : "Save to wishlist"
      }
      title={
        !signedIn
          ? "Sign in to save"
          : inWishlist
          ? "Remove from wishlist"
          : "Save to wishlist"
      }
    >
      {inWishlist ? (
        <Favorite sx={{ fontSize: 18 }} />
      ) : (
        <FavoriteBorder sx={{ fontSize: 18 }} />
      )}
    </button>
  );
}
